import styled, { css } from 'styled-components';

import { Box } from '@/components/Box';
import { NextImage } from '@/components/NextImage';
import { Typography } from '@/components/Typography';
export const CaliberWrapper = styled.div`
  display: flex;
  flex-direction: column;
  ${({ theme }) => css`
    padding: ${theme.spacing(0)};
    ${theme.media.md.up} {
      padding: ${theme.spacing(0, 2.5)};
    }
  `}
`;

export const Media = styled(Box)`
  object-fit: cover;
  flex: 1;
  aspect-ratio: 1;
`;
export const Image = styled(NextImage)`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;
export const Content = styled(Box)`
  ${({ theme }) => css`
    padding: ${theme.spacing(1.25, 2.5, 0)};
    ${theme.media.md.up} {
      padding-top: ${theme.spacing(1.25)};
    }
  `}
`;
export const Title = styled(Typography)`
  ${({ theme }) => css`
    text-transform: uppercase;
    font-size: ${theme.fontSizes.h5};
    margin-bottom: ${theme.spacing(1)};
    font-weight: ${theme.fontWeights.bold};
    font-family: ${theme.fontFamilies.italianPlate};
  `}
`;

export const Text = styled.p`
  ${({ theme }) => css`
    font-size: ${theme.fontSizes.p2};
    margin-bottom: ${theme.spacing(1)};
    font-weight: ${theme.fontWeights.extraLight};
    font-family: ${theme.fontFamilies.openSans};
    line-height: ${theme.lineHeights.p2};
  `}
`;

export const DescriptionGroup = styled.ul`
  ${({ theme }) => css`
    list-style: disc;
    padding-left: ${theme.spacing(2)};
    margin: ${theme.spacing(1.25, 0)};
  `}
`;

export const DescriptionItem = styled.li`
  ${({ theme }) => css`
    font-size: ${theme.fontSizes.p2};
    font-weight: ${theme.fontWeights.bold};
    font-family: ${theme.fontFamilies.openSans};
    line-height: ${theme.lineHeights.p2};
  `}
`;
